import React from 'react';

const Input = React.forwardRef(({ className = '', type = 'text', ...props }, ref) => {
  const baseClasses = "flex h-11 md:h-10 w-full rounded-md border border-gray-300 dark:border-gray-600 bg-white dark:bg-gray-700 px-3 py-2 text-sm text-gray-900 dark:text-white placeholder:text-gray-500 dark:placeholder:text-gray-400 ring-offset-white dark:ring-offset-gray-800 file:border-0 file:bg-transparent file:text-sm file:font-medium focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-highlight-500/30 focus-visible:ring-offset-2 focus-visible:border-highlight-500 disabled:cursor-not-allowed disabled:opacity-50 transition-all duration-200 hover:bg-gray-50 dark:hover:bg-gray-600";
  
  const classes = `${baseClasses} ${className}`.trim();

  return (
    <input
      type={type}
      className={classes}
      ref={ref}
      {...props}
    />
  );
});

Input.displayName = "Input";

export { Input }; 